import { clerkShadcnSafeColorVariables } from "@/components/auth/clerkShadcnThemeOverrides";

import { shadcn } from "@clerk/ui/themes";

const noShadow = {
  boxShadow: "none",
} as const;

/**
 * Shared Clerk appearance for auth screens — shadcn theme with flat
 * embedding inside AuthLayout (no nested card chrome or shadows).
 */
export const authClerkAppearance = {
  theme: shadcn,
  variables: {
    ...clerkShadcnSafeColorVariables,
    borderRadius: "var(--radius)",
    colorShadow: "transparent",
  },
  elements: {
    rootBox: "mx-0 w-full max-w-none",
    cardBox: {
      ...noShadow,
      borderWidth: 0,
      backgroundColor: "transparent",
      padding: 0,
      width: "100%",
      maxWidth: "100%",
    },
    card: {
      ...noShadow,
      borderWidth: 0,
      backgroundColor: "transparent",
      padding: 0,
      width: "100%",
      maxWidth: "100%",
      gap: "1rem",
    },
    header: { display: "none" },
    headerTitle: { display: "none" },
    headerSubtitle: { display: "none" },
    logoBox: { display: "none" },
    logoImage: { display: "none" },
    main: "w-full max-w-none gap-4 px-1 py-1",
    form: "flex w-full flex-col gap-4 px-1",
    formFieldRow: "w-full",
    formFields: "flex w-full flex-col gap-4",
    socialButtons: "flex w-full flex-col gap-2 px-1",
    socialButtonsBlockButton: {
      ...noShadow,
      width: "100%",
      height: "2.5rem",
      borderRadius: "var(--radius)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--input)",
      backgroundColor: "var(--muted)",
      fontSize: "0.875rem",
      fontWeight: 500,
      transition: "background-color 150ms ease, border-color 150ms ease",
      "&:hover": {
        ...noShadow,
        backgroundColor: "var(--accent)",
        borderColor: "var(--border)",
      },
    },
    dividerRow: "my-2 gap-4",
    dividerLine: "bg-border",
    dividerText: "text-xs text-muted-foreground",
    formFieldLabel: "text-sm font-medium leading-none",
    formFieldInput: {
      ...noShadow,
      boxSizing: "border-box",
      height: "2.5rem",
      borderRadius: "var(--radius)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--input)",
      backgroundColor: "transparent",
      padding: "0.375rem 0.75rem",
      fontSize: "0.875rem",
    },
    input: {
      ...noShadow,
      "&:hover": noShadow,
      "&:focus-within, &[data-focus-within=\"true\"]": noShadow,
    },
    formButtonPrimary: {
      ...noShadow,
      boxSizing: "border-box",
      width: "100%",
      height: "2.5rem",
      marginTop: "0.25rem",
      borderRadius: "var(--radius)",
      backgroundColor: "var(--primary)",
      color: "var(--primary-foreground)",
      padding: "0.375rem 1rem",
      fontSize: "0.875rem",
      fontWeight: 500,
    },
    button: {
      "&[data-variant=\"solid\"]": noShadow,
      "&[data-variant=\"outline\"]": noShadow,
      "&[data-variant=\"bordered\"]": noShadow,
    },
    formFieldInputShowPasswordButton: "text-muted-foreground hover:text-foreground",
    footer: { display: "none" },
    footerAction: { display: "none" },
    footerPages: { display: "none" },
    footerActionLink: "text-primary hover:text-primary/90",
    identityPreview: {
      ...noShadow,
      borderRadius: "var(--radius)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--input)",
      backgroundColor: "var(--muted)",
    },
    identityPreviewText: "text-sm",
    alternativeMethodsBlockButton: "text-sm text-primary hover:text-primary/90",
    formResendCodeLink: {
      color: "var(--foreground)",
      fontSize: "0.875rem",
      fontWeight: 500,
    },
    otpCodeFieldInput: {
      ...noShadow,
      borderRadius: "var(--radius)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--input)",
    },
    devBar: { display: "none" },
  },
};
